import React from 'react'
import ModalComponent from './ModalComponent'

export default function UploadUrl(props) {
    return (
        <div>
            {props.showModal ?
                <ModalComponent>
                    <div class="modal-dialog">
                        <div class="modal-content">
                            <div class="modal-header">
                                <button type="button" class="btn-close" aria-label="Close" onClick={() => props.closeModal()}></button>
                            </div>
                            <div class="modal-body">
                                {/* {changeUrl("")} */}
                                <div class="ratio ratio-1x1">
                                    <iframe src={props.uploadUrl}></iframe>

                                </div>
                            </div>
                            <div class="modal-footer">
                                {/* <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Copy & Close</button> */}
                            </div>
                        </div>
                    </div>
                </ModalComponent> : ""}
        </div>
    )
}
